// Updated App.js (with DaySessionProvider wrapped)

import React, { useEffect } from 'react';
import './App.scss';
import './Styles/Master.scss';
import firebase from 'firebase';
import firebaseConfig from '../src/chatapp/views/chat/config';
import Routes from './Routes/index';
import { actionCreators } from "./Redux";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { ChakraProvider } from '@chakra-ui/react';
import { Toaster } from 'react-hot-toast';
import runOneSignal from './Utils/webpush';

// 🔥 NEW: Import DaySessionProvider from your TimerOnHeader folder
import { DaySessionProvider } from './TimerOnHeader/DaySessionContext'; 

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
} else {
    firebase.initializeApp(firebaseConfig); // if already initialized, use that one
}

function App() {
    const state = useSelector(state => state)
    const dispatch = useDispatch();
    const { products2, customersList, admins, country, phoneCountryInput } = bindActionCreators(actionCreators, dispatch)

    useEffect(() => {
        customersList('q=')
        // admins()
        country()
        phoneCountryInput()
        products2()
        runOneSignal()
    }, [])

    return (
        <ChakraProvider>
            <Toaster />
            
            {/* 🔥 WRAP EVERYTHING with DaySessionProvider */}
            <DaySessionProvider>
                <div>
                    {<Routes />}
                </div>
            </DaySessionProvider>
            
        </ChakraProvider>
    );
}

export default App;